module.exports = __webpack_public_path__ + "img/live-aqua.65d62bb4.svg";